import { useState, useEffect } from 'react';

import { Box, Flex } from "@chakra-ui/react";
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal';


export default function DsrConfirmationModal({
  postIdToEdit,
  replyIdToEdit,
  confirmationType,
  handleCloseConfirmationModal,
  isMobileView,
  // Different function options,
  handleDeleteMessagePost,
  handleDeleteReply
}) {

  const [accentColor, setAccentColor] = useState('brandDark.500');
  const [confirmationTitle, setConfirmationTitle] = useState('');
  const [confirmationContent, setConfirmationContent] = useState('');
  const [confirmationButtonLabel, setConfirmationButtonLabel] = useState('');

  useEffect(() => {
    if (confirmationType) {
      switch (confirmationType) {
        case ('confirm-delete-post'): {
          setAccentColor('brandPink.500')
          setConfirmationTitle('Delete post')
          setConfirmationContent('This action cannot be undone - are you sure about deleting this post?')
          setConfirmationButtonLabel('Delete post')
          break;
        }
        case ('confirm-delete-reply'): {
          setAccentColor('brandPink.500')
          setConfirmationTitle('Delete reply')
          setConfirmationContent('This action cannot be undone - are you sure about deleting this reply?')
          setConfirmationButtonLabel('Delete reply')
          break;
        }
        default: {
          console.log(`ERROR: There is no such confirmationType: ${confirmationType}`)
          break
        }
      }
    }
  }, [confirmationType, handleDeleteMessagePost]);


  const renderConfirmationModalContent = () => {
    switch (confirmationType) {
      case ('confirm-delete-post'): {
        return (
          <Box p="1em 1.8em" w='100%'>
            <Flex justify='center' mb='1.6em' w='100%'>
              <Box w="100%" color='brandDark.500' fontSize='0.875em'>
                {confirmationContent}
              </Box>
            </Flex>

            <Flex w='100%' >
              <Flex my='0.625em' justify='flex-end' w='100%'>
                <LaunchdeckButton bg={accentColor} color='white' fontSize='0.8em' w={isMobileView && '100%'} onClick={() => handleDeleteMessagePost(postIdToEdit)} label={confirmationButtonLabel} />
              </Flex>
            </Flex>
          </Box>
        )
      }
      case ('confirm-delete-reply'): {
        return (
          <Box p="1em 1.8em" w='100%'>
            <Flex justify='center' mb='1.6em' w='100%'>
              <Box w="100%" color='brandDark.500' fontSize='0.875em'>
                {confirmationContent}
              </Box>
            </Flex>

            <Flex w='100%' >
              <Flex my='0.625em' justify='flex-end' w='100%'>
                <LaunchdeckButton bg={accentColor} color='white' fontSize='0.8em' w={isMobileView && '100%'} onClick={() => handleDeleteReply({ postIdToEdit, replyIdToEdit })} label={confirmationButtonLabel} />
              </Flex>
            </Flex>
          </Box>
        )
      }

      default: {
        console.log('There is no associated action with this confirmation type:', confirmationType)
        return null
      }
    }
  }

  return (
    <LaunchdeckModal
      title={confirmationTitle}
      handleCloseModal={handleCloseConfirmationModal}
      showModal={true}
      maxW='35em'
    >
      {renderConfirmationModalContent()}
    </LaunchdeckModal>
  )

}
